import { render, staticRenderFns } from "./AddonInformation.vue?vue&type=template&id=ac55224e&scoped=true"
import script from "./AddonInformation.vue?vue&type=script&lang=js"
export * from "./AddonInformation.vue?vue&type=script&lang=js"
import style0 from "./AddonInformation.vue?vue&type=style&index=0&id=ac55224e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac55224e",
  null
  
)

export default component.exports